import taskService from 'resources/task/task.service';
import * as taskApi from 'resources/task/task.api';
import { uploadDocumentsToTask } from 'resources/document/workflows';

const getNewTaskMilestoneOrder = async ({ milestoneId }) => {
  const milestoneTasks = await taskService.getMilestoneTasks(milestoneId);

  return milestoneTasks?.length;
};

const createTaskWithDocument = async ({ createTaskData, currentUser }) => {
  const { fileData, ...taskData } = createTaskData;

  const task = await taskService.createTask({
    ...taskData,
    milestoneOrder: taskData.milestoneOrder || await getNewTaskMilestoneOrder({ milestoneId: taskData.milestoneId }),
  });

  await uploadDocumentsToTask({
    fileData,
    taskId: task.id,
    taskCompanyId: task.company_id,
  });

  if (taskData.assigneeId && currentUser && taskData.assigneeId !== currentUser.id) {
    try {
      await taskApi.emailAssignee({ id: task.id });
    } catch (error) {
      // do not interrupt the flow if the email fails to send
      console.error('Error sending task assigned email', error);
    }
  }

  return task;
};

export {
  createTaskWithDocument,
};
